import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class AccordionGama extends Component {
  constructor(props) {
    super()

    this.state = {
      active: props.active || false,
    }

    this.handleActive = this.handleActive.bind(this)
  }

  static propTypes = {
    children: PropTypes.object.isRequired,
    active: PropTypes.bool,
    className: PropTypes.string,
  }

  handleActive = async () => {
    await this.setState((prevState) => ({ active: !prevState.active }))
  }

  render() {
    const { active } = this.state
    const { children, className } = this.props

    const headerClass = classNames('accordion-gama-header', { active })

    const contentClass = classNames('accordion-gama-content', { active })

    return (
      <section className={`accordion-gama ${className}`}>
        <div className={headerClass} onClick={this.handleActive}>
          <span>{!!children.title && children.title}</span>
          <i className='glyph glyph-double-arrow-down' />
        </div>

        <div className={contentClass}>
          {!!children.content && children.content}
        </div>
      </section>
    )
  }
}

export default AccordionGama
